module.exports = __webpack_public_path__ + "img/logo_manpro.c5ab3da2.png";